import React from 'react';
import { unescapeData } from '@root/src/lib/escapeData';
import { css } from 'emotion';
import { textSans } from '@guardian/src-foundations/typography';
import { text } from '@guardian/src-foundations/palette';
const emailCaptionStyle = css `
	${textSans.xsmall()};
	word-break: break-all;
	color: ${text.supporting};
`;
const embedContainer = css `
	iframe {
		/* Some embeds can hijack the iframe and calculate an incorrect width, which pushes the body out */
		width: 100% !important;
	}
`;
export const EmbedBlockComponent = ({ html, alt }) => {
    // TODO: Email embeds are being turned into atoms, so we can remove this hack when that happens
    const isEmailEmbed = html.includes('email/form');
    return (React.createElement("div", { "data-cy": "embed-block", className: embedContainer },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: unescapeData(html) } }),
        isEmailEmbed && alt && (React.createElement("div", { className: emailCaptionStyle }, alt))));
};
